/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Franchises_Loadmore1Inputs */

const id_franchises_loadmore1 = /** @type {(inputs: Franchises_Loadmore1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Muat lebih banyak`)
};

const ms_franchises_loadmore1 = /** @type {(inputs: Franchises_Loadmore1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Muat lagi`)
};

const da_franchises_loadmore1 = /** @type {(inputs: Franchises_Loadmore1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Indlæs mere`)
};

const de_franchises_loadmore1 = /** @type {(inputs: Franchises_Loadmore1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mehr laden`)
};

const en_us2_franchises_loadmore1 = /** @type {(inputs: Franchises_Loadmore1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Load more`)
};

const es_es2_franchises_loadmore1 = /** @type {(inputs: Franchises_Loadmore1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cargar más`)
};

const es_mx2_franchises_loadmore1 = /** @type {(inputs: Franchises_Loadmore1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cargar más`)
};

const fil_franchises_loadmore1 = /** @type {(inputs: Franchises_Loadmore1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mag-load pa`)
};

const fr_franchises_loadmore1 = /** @type {(inputs: Franchises_Loadmore1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Charger plus`)
};

const it_franchises_loadmore1 = /** @type {(inputs: Franchises_Loadmore1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Carica altro`)
};

const hu_franchises_loadmore1 = /** @type {(inputs: Franchises_Loadmore1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Több betöltése`)
};

const nl_franchises_loadmore1 = /** @type {(inputs: Franchises_Loadmore1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Meer laden`)
};

const no_franchises_loadmore1 = /** @type {(inputs: Franchises_Loadmore1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Last mer`)
};

const pl_franchises_loadmore1 = /** @type {(inputs: Franchises_Loadmore1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Załaduj więcej`)
};

const pt_br2_franchises_loadmore1 = /** @type {(inputs: Franchises_Loadmore1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Carregar mais`)
};

const pt_franchises_loadmore1 = /** @type {(inputs: Franchises_Loadmore1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Carregar mais`)
};

const ro_franchises_loadmore1 = /** @type {(inputs: Franchises_Loadmore1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Încarcă mai mult`)
};

const fi_franchises_loadmore1 = /** @type {(inputs: Franchises_Loadmore1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lataa lisää`)
};

const sv_franchises_loadmore1 = /** @type {(inputs: Franchises_Loadmore1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ladda fler`)
};

const vi_franchises_loadmore1 = /** @type {(inputs: Franchises_Loadmore1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tải thêm`)
};

const tr_franchises_loadmore1 = /** @type {(inputs: Franchises_Loadmore1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Daha fazla yükle`)
};

const cs_franchises_loadmore1 = /** @type {(inputs: Franchises_Loadmore1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Načíst více`)
};

const bg_franchises_loadmore1 = /** @type {(inputs: Franchises_Loadmore1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Заредете още`)
};

const ru_franchises_loadmore1 = /** @type {(inputs: Franchises_Loadmore1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Загрузить ещё`)
};

const uk_franchises_loadmore1 = /** @type {(inputs: Franchises_Loadmore1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Завантажити ще`)
};

const ar_franchises_loadmore1 = /** @type {(inputs: Franchises_Loadmore1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تحميل المزيد`)
};

const hi_franchises_loadmore1 = /** @type {(inputs: Franchises_Loadmore1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`और लोड करें`)
};

const th_franchises_loadmore1 = /** @type {(inputs: Franchises_Loadmore1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`โหลดเพิ่มเติม`)
};

const ja_franchises_loadmore1 = /** @type {(inputs: Franchises_Loadmore1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`さらに読み込む`)
};

const zh_cn2_franchises_loadmore1 = /** @type {(inputs: Franchises_Loadmore1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`加载更多`)
};

const zh_hant1_franchises_loadmore1 = /** @type {(inputs: Franchises_Loadmore1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`載入更多`)
};

const ko_franchises_loadmore1 = /** @type {(inputs: Franchises_Loadmore1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`더 보기`)
};

/**
* | output |
* | --- |
* | "Load more" |
*
* @param {Franchises_Loadmore1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const franchises_loadmore1 = /** @type {((inputs?: Franchises_Loadmore1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Franchises_Loadmore1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_franchises_loadmore1(inputs)
	if (locale === "ms") return ms_franchises_loadmore1(inputs)
	if (locale === "da") return da_franchises_loadmore1(inputs)
	if (locale === "de") return de_franchises_loadmore1(inputs)
	if (locale === "en-US") return en_us2_franchises_loadmore1(inputs)
	if (locale === "es-ES") return es_es2_franchises_loadmore1(inputs)
	if (locale === "es-MX") return es_mx2_franchises_loadmore1(inputs)
	if (locale === "fil") return fil_franchises_loadmore1(inputs)
	if (locale === "fr") return fr_franchises_loadmore1(inputs)
	if (locale === "it") return it_franchises_loadmore1(inputs)
	if (locale === "hu") return hu_franchises_loadmore1(inputs)
	if (locale === "nl") return nl_franchises_loadmore1(inputs)
	if (locale === "no") return no_franchises_loadmore1(inputs)
	if (locale === "pl") return pl_franchises_loadmore1(inputs)
	if (locale === "pt-BR") return pt_br2_franchises_loadmore1(inputs)
	if (locale === "pt") return pt_franchises_loadmore1(inputs)
	if (locale === "ro") return ro_franchises_loadmore1(inputs)
	if (locale === "fi") return fi_franchises_loadmore1(inputs)
	if (locale === "sv") return sv_franchises_loadmore1(inputs)
	if (locale === "vi") return vi_franchises_loadmore1(inputs)
	if (locale === "tr") return tr_franchises_loadmore1(inputs)
	if (locale === "cs") return cs_franchises_loadmore1(inputs)
	if (locale === "bg") return bg_franchises_loadmore1(inputs)
	if (locale === "ru") return ru_franchises_loadmore1(inputs)
	if (locale === "uk") return uk_franchises_loadmore1(inputs)
	if (locale === "ar") return ar_franchises_loadmore1(inputs)
	if (locale === "hi") return hi_franchises_loadmore1(inputs)
	if (locale === "th") return th_franchises_loadmore1(inputs)
	if (locale === "ja") return ja_franchises_loadmore1(inputs)
	if (locale === "zh-CN") return zh_cn2_franchises_loadmore1(inputs)
	if (locale === "zh-Hant") return zh_hant1_franchises_loadmore1(inputs)
	return ko_franchises_loadmore1(inputs)
});
export { franchises_loadmore1 as "franchises.loadMore" }